import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';
import IdealInfo from './sections/idealInfo';
import IdealBankSelect from './sections/IdealBankSelect';

const DURATION = 0.1;
const TRANSITIONS = {
  initial: {
    opacity: 0,
    transform: 'translateY(5px)',
  },
  initialUp: {
    opacity: 0,
    transform: 'translateY(-5px)',
  },
  enter: {
    opacity: 1,
    transform: 'translateY(0px)',
    transition: {
      duration: DURATION,
      when: 'beforeChildren',
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    transform: 'translateY(5px)',
    transition: {
      duration: DURATION,
      ease: 'easeOut',
    },
  },
  exitUp: {
    opacity: 0,
    transform: 'translateY(-5px)',
    transition: {
      duration: DURATION,
      ease: 'easeOut',
    },
  },
};

const IdealOption = ({ setSelectedPaymentMethod, stripe, innerRef }) => {
  const [formStep, setFormStep] = useState(1);

  return (
    <AnimatePresence initial={false} exitBeforeEnter>
      {formStep === 1 && (
        <motion.div
          key="ideal-info"
          variants={TRANSITIONS}
          initial="initialUp"
          animate="enter"
          exit="exitUp"
        >
          <IdealInfo
            setFormStep={setFormStep}
            setSelectedPaymentMethod={setSelectedPaymentMethod}
          />
        </motion.div>
      )}
      {formStep === 2 && (
        <motion.div
          key="ideal-payment"
          variants={TRANSITIONS}
          initial="initial"
          animate="enter"
          exit="exit"
        >
          <IdealBankSelect innerRef={innerRef} setFormStep={setFormStep} stripe={stripe} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

IdealOption.propTypes = {
  setSelectedPaymentMethod: PropTypes.func,
  stripe: PropTypes.object,
  innerRef: PropTypes.shape({ current: PropTypes.any }),
};

IdealOption.defaultProps = {
  setSelectedPaymentMethod: undefined,
  stripe: undefined,
  innerRef: undefined,
};

export default IdealOption;
